import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useGetRulesLogsQuery } from "@/services/it/updates/rules/query-rules";
import { Load } from "components/load";
import { Badge } from "components/ui/badge";
import { ScrollText, User, Check, AlignJustify } from "lucide-react";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';


export function RulesLogModal() {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const { data: logs, isLoading } = useGetRulesLogsQuery({
    search: filters.search,
    orderBy: JSON.stringify("desc"),
    perPage: filters.meta.perPage || 30,
    meta: {
      page: filters?.meta?.page || 1,
    },
  });

  if (isLoading) return <Load />;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="border border-black/20 hover:bg-black/5 transition-all ease-in-out duration-300 rounded-full p-2 cursor-pointer">
          <ScrollText size={14} />
        </div>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[700px] bg-white">
        <DialogHeader>
          <DialogTitle className="text-center">
            Histórico de Alteração nas Regras
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[400px] mt-4 border rounded-md">
          {logs?.data && logs?.data?.length > 0 ? (
            logs.data.map((log) => (
              <div
                className="flex flex-col space-y-2 p-4 border-b last:border-b-0"
                key={log.id}
              >
                <div className="flex justify-between items-center mb-1">
                  <Badge
                    variant="outline"
                    className="bg-blue-100 text-blue-800"
                  >
                    ID: {log.id}
                  </Badge>
                  <span className="text-sm text-gray-500">
                    {log?.created_at
                      ? format(new Date(log.created_at), "dd/MM/yy HH:mm", {
                          locale: ptBR,
                        }).replace(", ", " - ")
                      : ""}
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-4">
                  <div className="flex items-center space-x-2">
                    <User size={16} className="text-gray-500" />
                    <div>
                      <p className="text-xs font-semibold">Responsável</p>
                      <p className="text-sm">{log?.changed_by?.name}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Check size={16} className="text-gray-500" />
                    <div>
                      <p className="text-xs font-semibold">
                        Aprovação Automática
                      </p>
                      <p className="text-sm">{log?.auto_approval}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <AlignJustify size={16} className="text-gray-500" />
                    <div>
                      <p className="text-xs font-semibold">Máximo de linhas</p>
                      <p className="text-sm">{log?.max_query}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-sm text-gray-500 flex items-center justify-center mt-4">
              Nenhum Log.
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
